import React from 'react'

const PageInfo = () => {
    return (
        <>
            <div className="titles">
                <h3 className="pageTitle">
                    Portfolio
                </h3>
                <p className="pageDesc">Check my portfolio</p>

            </div>
        </>
    )
}

export default PageInfo
